import { useLayoutEffect, useRef } from "react";
import { holdPageUpdate } from "../lib/page-update-safety";

export function usePageUpdateGuard(blocked) {
  const token = useRef(Symbol("page-update-guard"));
  useLayoutEffect(() => {
    const id = token.current;
    holdPageUpdate(id, blocked);
    return () => holdPageUpdate(id, false);
  }, [blocked]);
}